import { Area, AreaChart, ResponsiveContainer } from 'recharts'

export const RecommendedLeadChart = ({
   totalLeads,
   appointments,
   index,
}: {
   totalLeads: number
   appointments: number
   index: number
}) => {
   const data = [
      {
         uv: totalLeads,
         pv: (appointments / totalLeads) * 100 + 40,
      },
      {
         uv: totalLeads,
         pv: (appointments / totalLeads) * 100 + 40,
      },
      {
         uv: totalLeads / 3,
         pv: (appointments / totalLeads) * 100 + 20,
      },
      {
         uv: totalLeads / 3,
         pv: (appointments / totalLeads) * 100 + 20,
      },
   ]
   const bgColors = ['#51258F', '#146262', '#203175']
   const highlightBgColors = ['#642AB5', '#138585', '#7F9EF3']

   return (
      <>
         <ResponsiveContainer width="100%" height={115}>
            <AreaChart
               data={data}
               margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
            >
               <defs>
                  <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                     <stop
                        offset="0%"
                        stopColor={`${bgColors[index % bgColors.length]}`}
                        stopOpacity={0.1}
                     />
                     <stop
                        offset="100%"
                        stopColor={`${
                           highlightBgColors[index % highlightBgColors.length]
                        }`}
                        stopOpacity={1}
                     />
                  </linearGradient>
                  <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                     <stop
                        offset="0%"
                        stopColor={`${bgColors[index % bgColors.length]}`}
                        stopOpacity={0.1}
                     />
                     <stop
                        offset="100%"
                        stopColor={`${
                           highlightBgColors[index % highlightBgColors.length]
                        }`}
                        stopOpacity={1}
                     />
                  </linearGradient>
               </defs>
               <Area
                  type="monotone"
                  dataKey="uv"
                  stroke="transparent"
                  fillOpacity={0.7}
                  fill="url(#colorUv)"
               />
               <Area
                  type="monotone"
                  dataKey="pv"
                  stroke="transparent"
                  fillOpacity={0.7}
                  fill="url(#colorPv)"
               />
            </AreaChart>
         </ResponsiveContainer>
      </>
   )
}
